<template>
  <div class="select-insu-container">
    <div class="select-insu-content">
      <h2 class="title">관심있는 보험 종목을 선택해주세요.</h2>
      <p class="subtitle">• 중복 선택 가능 •</p>
      
      <div class="insurance-grid">
        <div 
          v-for="(insurance, index) in insurances" 
          :key="index" 
          class="insurance-item"
          @click="toggleInsurance(insurance)"
        >
          <div 
            class="insurance-box" 
            :class="{ 'selected': selectedInsurances.includes(insurance) }"
          ></div>
          <div class="insurance-name">{{ insurance }}</div>
        </div>
      </div>
      
      <div class="button-container">
        <button class="button button-prev" @click="$emit('close')">이전</button>
        <button 
        class="button button-next" 
        :class="{ 'button-disabled': selectedInsurances.length === 0 }"
        :disabled="selectedInsurances.length === 0"
        @click="submitSelection"
      >
        다음
      </button>
      </div>
    </div>
    <div class="overlay" v-if="showInputName">
      <inputName 
        v-bind="{ pn, refin, sorce, me }"
        @close="showInputName = false"
        @resetValue="resetValue"
      />
    </div>
  </div>
</template>

<script>
import inputName from './Step2.vue'
export default {
  components: {
    inputName
  },
  props: {
    refin: { type: String, default: '' },
    sorce: { type: String, default: '' },
    pn: { type: String, default: '' },
  },
  emits: ['resetValue'],
  data() {
    return {
      insurances: [
        '자동차보험', '운전자보험', '실손의료보험', '암/2대질병보험',
        '어린이보험', '태아보험', '정기보험', '종신보험',
        '화재보험', '연금보험', '치아보험', '치매보험',
        '펫보험', '원데이보험', '여행보험'
      ],
      selectedInsurances: [],
      me: '', // 선택된 보험의 문자열
      showInputName: false,
    }
  },
  computed: {
    isNextButtonEnabled() {
      return this.selectedInsurances.length > 0;
    }
  },
  methods: {
    toggleInsurance(insurance) {
      const index = this.selectedInsurances.indexOf(insurance);
      if (index > -1) {
        this.selectedInsurances.splice(index, 1);
      } else {
        this.selectedInsurances.push(insurance);
      }
    },
    submitSelection() {
      if (this.isNextButtonEnabled) {
        this.me = this.selectedInsurances.join('|');
        this.showInputName = true
        console.log('선택된 보험:', this.me);
      }
    },
    resetValue() {
      this.me = ''
      this.selectedInsurances = []
      this.showInputName = false;
      console.log('emit으로 리셋 step1');
      this.$emit('resetValue')
    }
  },
}
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.css");

:root {
  --font-pretendard: Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
}

body {
  font-family: var(--font-pretendard);
}

.select-insu-container {
  width: 100%;
  height: 920px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.select-insu-content {
  background: #ffffff;
  width: 1194px;
  height: 834px;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.title {
  color: #000000;
  text-align: center;
  font-family: var(--font-pretendard);
  font-size: 36px;
  letter-spacing: 0.03em;
  font-weight: 600;
  position: absolute;
  left: calc(50% - 261px);
  top: 23px; /* 43px에서 20px 위로 이동 */
}

.subtitle {
  color: var(--grays-gray, #8e8e93);
  text-align: center;
  font-family: var(--font-pretendard);
  font-size: 20px;
  letter-spacing: 0.03em;
  font-weight: 500;
  position: absolute;
  left: calc(50% - 75px);
  top: 96px; /* 116px에서 20px 위로 이동 */
}

.insurance-grid {
  background: #f2f2f7;
  border-radius: 32px;
  border: 2px solid var(--grays-gray-4, #d1d1d6);
  width: 950px;
  height: 450px;
  position: absolute;
  left: 122px;
  top: 140px; /* 160px에서 20px 위로 이동 */
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  padding: 20px;
}

.insurance-item {
  position: relative;
  width: 200px;
  height: 80px;
  cursor: pointer;
}

.insurance-box {
  background: #ffffff;
  border-radius: 20px;
  border: 1.5px solid var(--grays-gray-4, #d1d1d6);
  width: 100%;
  height: 100%;
  transition: all 0.3s ease;
}

.insurance-box.selected {
  background: #DCE1F5;
  border: 2px solid #A1B5F0;
}

.insurance-name {
  color: #000000;
  text-align: center;
  font-family: var(--font-pretendard);
  font-size: 28px;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  pointer-events: none;
}

.button-container {
  position: absolute;
  bottom: 130px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 20px;
}

.button {
  border-radius: 36px;
  width: 280px;
  height: 64px;
  font-family: var(--font-pretendard);
  font-size: 28px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.button-prev {
  background:  #c7c7cc;
  color: #ffffff;
}

.button-next {
  background: #184de5;
  color: #ffffff;
}

.button-disabled {
  background:  #c7c7cc;
  cursor: not-allowed;
}

.overlay {
  position: absolute; /* fixed에서 absolute로 변경 */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

</style>